// queries/getProfileBanner.ts
import { ProfileBanner } from '../types';
import { profileBanner } from '../data/portfolioData';

// DatoCMS (original) — replace with your own project if needed
// import datoCMSClient from './datoCMSClient';
// const GET_PROFILE_BANNER = `...`;
// export async function getProfileBanner(): Promise<ProfileBanner> {
//   const data = await datoCMSClient.request<{ profilebanner: ProfileBanner }>(GET_PROFILE_BANNER);
//   return data.profilebanner;
// }

export async function getProfileBanner(): Promise<ProfileBanner> {
  return profileBanner;
}
